export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';

export const UPDATE_AUTH_USER = 'update_auth_user';
export const UPDATE_LOAD_USER = 'update_load_user';
export const SEND_FORGET_PASSWORD_EMAIL = 'send_forget_password_email';
// export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
// export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
// export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
// export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';

//Account

export const GET_ACCOUNTS = 'get_account_facebook';
export const UPDATE_ACCOUNTS = 'update_account_facebook';
export const CREATE_ACCOUNTS = 'create_account_facebook';
export const OPENING_BROWER = 'opening_browser';
export const OPEN_BROWER_SUCCESS = 'open_browser_success';
export const CLOSING_BROWER = 'closing_browser';
export const CLOSE_BROWER_SUCCESS = 'close_browser_success';
export const SELECTED_ACCOUNT = 'selected_account';
export const DELETE_ACCOUNT = 'delete_account';
export const SELECTED_DEFAULT = 'selected_default';
export const GET_ACCOUNTS_BY_ID_GROUP = 'get_accounts_by_id_group';
export const SET_ACCOUNTS_BY_ID_GROUP = 'set_accounts_by_id_group';
export const CLOSE_ALL_BROWSER = 'close_all_browser';
export const SET_ACCOUNT_SHARED = "set_account_shared";
export const SET_ACCOUNT_SHARE_WITH_ME = "set_account_share_with_me";
export const SET_SCAN_ACCOUNT = "set_scan_account";

// Users Module
// export const GET_USERS = 'GET_USERS';
// export const ADD_USER = 'ADD_USER';
// export const SET_USER_DETAILS = 'SET_USER_DETAILS';
// export const EDIT_USER = 'EDIT_USER';
// export const DELETE_USER = 'DELETE_USER';
// export const DELETE_BULK_USERS = 'DELETE_BULK_USERS';

// Notification
export const NOTIFICATION_ERROR = 'notification_error';
export const NOTIFICATION_SUCCESS = 'notification_success';
export const NOTIFICATION_WARNING = 'notification_warning';
export const NOTIFICATION_OFF = 'notification_off';
// manage the script
export const CREATE_NEW_SCRIPT = 'create_new_script';
export const DELETE_SCRIPT = 'delete_script';
export const GET_SCRIPTS = 'get_scripts';
export const UPDATE_SCRIPT = 'update_script';

export const ADD_LIST_ACCOUNT = 'add_list_account';
export const REMOVE_LIST_ACCOUNT = 'remove_list_account';
export const SET_ACCOUNTS_FOR_ACTION = 'set_accounts_for_action';
export const REMOVE_ACCOUNT_FOR_ACTION = 'remove_account_for_action';
// action facebook
export const ADD_NEW_ACTION = 'add_new_action';
export const DELETE_ACTION = 'delete_action';
export const UPDATE_ACTION = 'update_action';
export const SET_ALL_ACTION = 'set_all_action';
// change element
export const CHANGE_MODIFY_BUTTON_SCRIPT = 'change_modify_button_script';
export const CHANGE_CREAT_BUTTON_SCRIPT = 'change_create_button_script';
// popup infomation account facebook
export const SET_OPEN_POPUP = 'set_open_popup';
export const SET_CLOSE_POPUP = 'set_close_popup';
// post facebook
export const GET_POSTS_FACEBOOK = 'get_posts_facebook';
export const SET_NAME_POST = 'set_name_post';
export const SET_CONTENT_POST = 'set_content_post';
export const SET_URL_IMG_POST = 'set_url_img_post';
export const SET_ID_POST_CURRENT = 'set_id_post_current';
export const SET_POST = 'set_post';
export const SET_SELECTED_POSTS = 'set_selected_posts';
export const OPEN_MODIFY_POPUP_POST = 'open_modify_popup_post';
export const CLOSE_MODIFY_POPUP_POST = 'close_modify_popup_post';
export const SET_UPDATE_BUTTON = 'set_update_button';
export const SET_CREATE_BUTTON = 'set_create_button';
// groups
export const CREATE_GROUP = 'create_group';
export const UPDATE_GROUP = 'update_group';
export const DELETE_GROUP = 'delete_group';
export const ADD_ACCOUNTS_GROUP = 'add_account_group';
export const GET_GROUPS = 'get_groups';
export const ADD_SELECTED_GROUP = 'add_selected_group';
export const RELOAD_SELECTED_GROUP = "reload_selected_group";
export const OPEN_MODIFY_POPUP_GROUP = 'open_mofify_popup_group';
export const CLOSE_MODIFY_POPUP_GROUP = 'close_mofify_popup_group';
export const OPEN_ADD_ACCOUNT_POPUP_GROUP = 'open_add_account_popup_group';
export const CLOSE_ADD_ACCOUNT_POPUP_GROUP = 'close_add_account_popup_group';
export const REMOVE_ACCOUNTS_GROUP = 'remove_accounts_group';
export const SET_DATA_SYNC_GROUP = "set_data_sync_group";
//Pages
export const CREATE_PAGE = 'create_page';
export const DELETE_PAGE = 'delete_page';
export const UPDATE_PAGE = 'update_page';
export const GET_PAGE = 'get_page';
export const SET_OPEN_LIST_PAGE = 'set_open_list_page';
export const SET_CLOSE_LIST_PAGE = 'set_close_list_page';
export const SET_OPEN_POPUP_ADD_PAGE = 'set_open_popup_add_page';
export const SET_CLOSE_POPUP_ADD_PAGE = 'set_close_popup_add_page';
export const SET_OPEN_POPUP_UPDATE_PAGE = 'set_open_popup_update_page';
export const SET_CLOSE_POPUP_UPDATE_PAGE = 'set_close_popup_update_page';
export const GET_ALL_PAGE = "get_all_page";

//Category
export const GET_CATEGORIES = "get_categories"
export const CREATE_CATEGORY = "create_category"
export const UPDATE_CATEGORY = "update_category"
export const DELETE_CATEGORIES = "delete_categories"

//question
export const GET_QUESTIONS = "get_questions"
export const CREATE_QUESTION = "create_question"
export const UPDATE_QUESTION = "update_question"
export const DELETE_QUESTIONS = "delete_questions"

//province
export const GET_PROVINCES = "get_provinces"
export const GET_DISTRICTS = "get_districts"

//user account
export const GET_USER_ACCOUNTS = "get_user_accounts";

export const UPDATE_PERCENT_DOWNLOAD = "update_percent_download";
export const UPDATE_STATUS_DOWNLOAD = "update_status_download";

export const SET_STATUS_POPUP_REVOKE_SHARE = "set_status_popup_revoke_share";

export const UPDATE_SETTING_TABLE = "update_setting_table";

export const GET_USER_PROXY = "get_user_proxy";